module.exports = __webpack_public_path__ + "static/how-it-works-a389fb4973d926894366d8ffa0f6343a.svg";